import React from 'react';
import { useNewUI } from 'hooks/useNewUI';
import CheckGreen from '../../Assets/check-circle.png';
import ClockPending from '../../Assets/clockpending.png';
import styles from './SuccessPopUp.module.css';
import { useSuccessPopup } from './successPopupShared';
import { UPLOAD_BLOCKER_FEATURES } from './uploadBlockerShared';
import SuccessPopUpV2 from './SuccessPopUpV2';

// Post-purchase success popup. A thin router: new-UI accounts get the v2
// presentation, everyone else the redesigned classic card below. Both share the
// same behaviour via useSuccessPopup, so only the look differs.
function SuccessPopUp(props) {
  const { enabled: isNewUI } = useNewUI();
  if (isNewUI) return <SuccessPopUpV2 {...props} />;
  return <SuccessPopUpClassic {...props} />;
}

function SuccessPopUpClassic({
  expressData,
  onHide,
  paymentStatus,
  paymentNavigation,
  setOpenPaymentLoader,
  isGift = false,
  isSwitchSuccess = false,
}) {
  const {
    isSuccess, isTrial, endDate, amountText, showRenewal, handleClose, handleRetry,
  } = useSuccessPopup({
    expressData, onHide, paymentStatus, paymentNavigation, setOpenPaymentLoader, isSwitchSuccess,
  });

  const planName = expressData?.plan_name;
  const primaryLabel = paymentStatus === 'affliate' || isGift ? 'Done' : 'Continue';

  const trialNote = isTrial && endDate ? `Trial ends on ${endDate}` : '';

  return (
    <div className={styles.overlay}>
      <div className={styles.card}>
        <button type="button" className={styles.close} onClick={handleClose} aria-label="Close">
          &times;
        </button>

        <div className={`${styles.iconWrap} ${isSuccess ? styles.iconSuccess : styles.iconError}`}>
          <img src={isSuccess ? CheckGreen : ClockPending} alt="" />
        </div>

        {isSuccess ? (
          <>
            {/* eslint-disable-next-line no-nested-ternary */}
            <h2 className={styles.title}>{isGift ? 'Gift sent successfully' : isTrial ? 'Trial Activated' : 'Payment successful'}</h2>
            <p className={styles.subtitle}>
              {isGift ? 'You gifted the ' : "You're on the "}
              <span className={styles.plan}>{planName || 'new'}</span>
              {' plan.'}
              <br />
              {isGift ? 'Your recipient now has access to:' : 'You now have access to:'}
            </p>

            <div className={styles.features}>
              {UPLOAD_BLOCKER_FEATURES.map((f) => (
                <div key={f} className={styles.feature}>
                  <img src={CheckGreen} alt="" />
                  {f}
                </div>
              ))}
            </div>

            {isTrial ? (
              trialNote && (
                <div className={styles.meta}>
                  <div className={styles.metaNote}>{trialNote}</div>
                </div>
              )
            ) : (
              (amountText || (showRenewal && endDate)) && (
                <div className={styles.meta}>
                  {amountText && (
                    <div className={styles.metaRow}>
                      <span className={styles.metaLabel}>Amount paid</span>
                      <span className={styles.metaValue}>{amountText}</span>
                    </div>
                  )}
                  {showRenewal && endDate && (
                    <div className={styles.metaRow}>
                      <span className={styles.metaLabel}>Next renewal</span>
                      <span className={styles.metaValue}>{endDate}</span>
                    </div>
                  )}
                </div>
              )
            )}

            <button type="button" className={styles.primaryBtn} onClick={handleClose}>
              {primaryLabel}
            </button>
          </>
        ) : (
          <>
            <h2 className={styles.title}>Payment unsuccessful</h2>
            <p className={styles.subtitle}>
              Your purchase didn&apos;t go through. No charge was made — please try again.
            </p>
            <button type="button" className={`${styles.primaryBtn} ${styles.retryBtn}`} onClick={handleRetry}>
              Retry your Purchase
            </button>
          </>
        )}
      </div>
    </div>
  );
}

export default SuccessPopUp;
